export default class WebXRHandler {
	constructor(options) {
		this.ARMode = {
			QUICK_LOOK: 'quick-look',
			AR_VIEWER: 'ar-viewer',
			UNSTABLE_WEBXR: 'unstable-webxr',
			NONE: 'none'
		};
		this.arMode = this.ARMode.NONE;
		this.updateArMode();
		if (options) {
			this.setOptions(options);
		}
	}

	setOptions(options) {
		if (options.arUnsupported) this.arUnsupported = options.arUnsupported;
	}

	updateArMode() {
		// Get Flags
		const IS_ANDROID = /android/i.test(navigator.userAgent);
		const IS_IOS =
			/iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream;
		const IS_IOS_SAFARI = IS_IOS && /Safari\//.test(navigator.userAgent);
		const IS_AR_QUICKLOOK_CANDIDATE = (() => {
			const tempAnchor = document.createElement('a');
			return Boolean(
				tempAnchor.relList &&
					tempAnchor.relList.supports &&
					tempAnchor.relList.supports('ar')
			);
		})();

		// Work out AR Mode based on what flags we have.
		const arViewerCandidate = IS_ANDROID && navigator.xr;
		const iosQuickLookCandidate =
			IS_IOS && IS_AR_QUICKLOOK_CANDIDATE && IS_IOS_SAFARI;

		if (arViewerCandidate) {
			this.arMode = this.ARMode.AR_VIEWER;
		} else if (iosQuickLookCandidate) {
			this.arMode = this.ARMode.QUICK_LOOK;
		} else {
			this.arMode = this.ARMode.NONE;
		}
	}

	// example argument
	// Got to be https, android doesn't like models served locally
	// const model = {
	// 	gltf: 'https://lab.pikcells.com/assets/models/table/Correct_Scale.gltf', // Doesn't work from local server
	// 	usdz:
	// 		'https://10.3.222.84:3000/src/models/table/PBR - Metallic Roughness.usdz',
	// 	arTitle: 'Tap',
	// 	arTitleLink: 'https://10.3.222.84:3000',
	// 	arFallbackLink: 'https://10.3.222.84:3000' // Shouldn't be needed
	// };

	enterAR(model) {
		// alert(this.arMode);
		if (this.arMode == this.ARMode.AR_VIEWER) {
			// Android
			this.openARViewer(
				model.gltf, // Model location
				model.arTitleLink, // Title Link
				model.arTitle,
				model.arFallbackLink // No AR Fallback link
			);
		} else if (this.arMode == this.ARMode.QUICK_LOOK) {
			// iOS
			this.openIOSARQuickLook(
				model.usdz // Model location
			);
		} else if (this.arUnsupported) {
			this.arUnsupported();
		} else {
			alert(
				'Device or Browser not AR compatible. Try this on iOS Safari or Android Chrome.'
			);
		}
	}

	openARViewer(gltfSrc, location, title, fallback) {
		// Construct url for google chrome
		const anchor = document.createElement('a');
		const noArViewerSigil = '#model-viewer-no-ar-fallback';
		const locationUrl = new URL(location);
		const modelUrl = new URL(gltfSrc);
		const fallbackUrl = new URL(fallback);
		const link = encodeURIComponent(location);
		const scheme = modelUrl.protocol.replace(':', '');
		locationUrl.hash = noArViewerSigil;
		title = encodeURIComponent(title);
		modelUrl.protocol = 'intent://';
		const intent = `${modelUrl.toString()}?link=${link}&title=${title}#Intent;scheme=${scheme};package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
			fallbackUrl.toString()
		)};end;`;

		// go to the url
		anchor.setAttribute('href', intent);
		anchor.click();
	}

	openIOSARQuickLook(usdzSrc) {
		// Go to the url in safari
		// You might needs mime types setting on the server for this to work: usdz -> 'model/vnd.pixar.usd'
		const anchor = document.createElement('a');
		anchor.setAttribute('rel', 'ar'); // Need this flag
		anchor.appendChild(document.createElement('img'));
		anchor.setAttribute('href', usdzSrc);
		anchor.click();
	}
}
